var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[_c('Aside'),_c('HeaderMobile'),_c('Form'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }